import React from 'react';
import styled from 'styled-components';

interface CardContentProps {
  children?: React.ReactNode;
}

interface StyledCardContentProps {
  children?: React.ReactNode;
}

const StyledCardContent = styled.div<StyledCardContentProps>`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${(props) => props.theme.spacing[4]}px;
`;

const CardContent = ({ children }: CardContentProps) => {
  const hasChildren = React.Children.count(children) > 0;
  
  return (
    <StyledCardContent>
      {hasChildren ? <>{children}</> : null}
    </StyledCardContent>
  );
};

CardContent.defaultProps = {
  children: null,
};

export default CardContent;
